import React, { useState } from "react";

import styles from "./Playlist.module.css";

import { t } from "i18next";

import "react-alice-carousel/lib/alice-carousel.css";
import AliceCarousel from "react-alice-carousel";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { LockFilled } from "@ant-design/icons";
import { Collapse } from "antd";

import { ITalk } from "../../interfaces/talk";
import MenuIcon from "../icons/MenuIcon";
import { ArrowLeft } from "../icons/ArrowLeft";
import { ArrowRight } from "../icons/ArrowRight";

const DEFAULT_THUMB_IMAGE =
  "https://static.eventials.com/static/images/talk_thumb.svg";

interface IProps {
  playlistName: string;
  playlistSlug: string;
  talks: ITalk[];
  channel: string;
  currentTalk: ITalk;
}

const getHeader = (
  playlistOpen: boolean,
  currentTalk: ITalk,
  nextTalk: ITalk,
  playlistName: string,
  channel: string,
  playlistSlug: string
) => {
  if (playlistOpen) {
    return (
      <span className={styles.talkTitle1} style={{ color: "#FCFCFC" }}>
        {playlistName.toUpperCase()}
      </span>
    );
  } else {
    return (
      <>
        <div>
          <span
            className={styles.talkTitle1}
            style={{ lineHeight: 1, color: "#FF3655" }}
          >
            {t("playlist.reproducing").toUpperCase()}
          </span>
          <span
            className={styles.currentTalkTtitle}
            style={{ color: "#FCFCFC" }}
          >
            {currentTalk.title}
          </span>
        </div>
        {nextTalk && (
          <>
            <ArrowRight size={24} color="#A0A3BD" />
            <div className={styles.onHover} onClick={() => {}}>
              <span className={styles.nextTalkTitle}>
                {t("playlist.next").toUpperCase()}
              </span>
              <a
                style={{ width: "100%" }}
                href={
                  "/" +
                  channel +
                  "/" +
                  nextTalk.slug +
                  "/?playlist=" +
                  playlistSlug
                }
              >
                <span className={styles.currentTalkTtitle} color="line">
                  {nextTalk.title}
                </span>
              </a>
            </div>
          </>
        )}
      </>
    );
  }
};

export const Playlist = ({
  talks,
  playlistName,
  playlistSlug,
  currentTalk,
  channel,
}: IProps) => {
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const nextTalk =
    talks[
      talks.indexOf(currentTalk) > talks.length
        ? 0
        : talks.indexOf(currentTalk) + 1
    ];

  return (
    <div className={styles.container}>
      <Collapse
        style={{ border: 0 }}
        expandIcon={() => <MenuIcon color="#FFF" />}
        onChange={() => setPlaylistOpen(!playlistOpen)}
      >
        <CollapsePanel
          header={
            <div className={styles.header}>
              {getHeader(
                playlistOpen,
                currentTalk,
                nextTalk,
                playlistName,
                channel,
                playlistSlug
              )}
            </div>
          }
          key={0}
        >
          <AliceCarousel
            keyboardNavigation={true}
            paddingLeft={38}
            paddingRight={135}
            activeIndex={talks.indexOf(currentTalk)}
            autoWidth={true}
            mouseTracking={true}
            renderNextButton={() => (
              <button className={styles.carouselButton} style={{ right: 0 }}>
                <ArrowRight color="#FFF" size={24} />
              </button>
            )}
            renderPrevButton={() => (
              <button className={styles.carouselButton} style={{ left: 0 }}>
                <ArrowLeft color="#FFF" size={24} />
              </button>
            )}
            disableDotsControls={true}
            infinite={false}
          >
            {talks.map((talk: ITalk, index: number) => (
              <a
                className={styles.carouselItem}
                href={
                  "/" + channel + "/" + talk.slug + "/?playlist=" + playlistSlug
                }
                key={talk.id}
              >
                <div className={styles.thumb}>
                  <img
                    src={talk.cover || DEFAULT_THUMB_IMAGE}
                    alt={`cover of webinar ${talk.title}`}
                  />
                  <div>
                    <span className={styles.thumnText} style={{ flex: 1 }}>
                      {index + 1}
                    </span>
                    {currentTalk.id === talk.id && (
                      <span className={styles.thumnText}>
                        {t("playlist.reproducing")}
                      </span>
                    )}
                    {!talk.is_public && (
                      <LockFilled
                        style={{ marginLeft: "8px" }}
                        color="#FFF"
                        size={14}
                      />
                    )}
                  </div>
                </div>
                <span
                  className={styles.talkTitle2}
                  color={currentTalk.id === talk.id ? "white" : "placeholder"}
                >
                  {talk.title}
                </span>
              </a>
            ))}
          </AliceCarousel>
        </CollapsePanel>
      </Collapse>
    </div>
  );
};
